import { Component, inject } from '@angular/core';
import { ImportFlowService } from '@services/imports/import-flow.service';
import { OrderSliSettingsTable } from '@/table-settings/imports/order-sli-settings-table';
import { TableColumnsSetting } from '@/interfaces/table-setting';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { OrderSliDataSource } from '@components/new-table/data-sources/order-sli.dataSource';

@Component({
  selector: 'app-order-sli-table',
  templateUrl: './order-sli-table.component.html',
  styleUrls: ['./order-sli-table.component.scss'],
})
export class OrderSliTableComponent {
  displayedColumns: TableColumnsSetting<any>;
  dataSource = new OrderSliDataSource(this.importFlowService);
  toastr = inject(ToastrService);
  dialog = inject(MatDialog);
  reloadTrigger$ = new Subject<any>();

  constructor(private importFlowService: ImportFlowService) {
    this.displayedColumns = OrderSliSettingsTable.getColumnsSetting();
  }
}
